"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtil = /** @class */ (function () {
    function StringUtil() {
    }
    StringUtil.is_number = function (str) {
        return !(this.is_blank(str) || isNaN(str));
    };
    StringUtil.is_blank = function (str) {
        return (!str || !str.trim());
    };
    StringUtil.lines = function (str) {
        return str.split('\n');
    };
    StringUtil.replace_all = function (str, search, replacement) {
        return str.replace(new RegExp(search, 'g'), replacement);
    };
    StringUtil.remove = function (str) {
        var char = [];
        for (var _a = 1; _a < arguments.length; _a++) {
            char[_a - 1] = arguments[_a];
        }
        for (var i = 0; i < char.length; i++) {
            str = this.replace_all(str, char[i], '');
        }
        return str;
    };
    StringUtil._i = function (str) {
        if (!StringUtil.is_number(str)) {
            throw new TypeError("StringUtil: Unable to parse '" + str + "' to number");
        }
        return Number(str);
    };
    StringUtil._json = function (str) {
        return JSON.parse(str);
    };
    StringUtil.secs = function (str) {
        return this._i(str) * 1000;
    };
    StringUtil.mins = function (str) {
        return this._i(str) * 60000;
    };
    StringUtil.hours = function (str) {
        return this._i(str) * 3600000;
    };
    StringUtil.days = function (str) {
        return this._i(str) * 86400000;
    };
    return StringUtil;
}());
exports.StringUtil = StringUtil;
